export default __webpack_public_path__ + "static/media/logo.2729cad7.png";